import { useRef } from "react";
import { UserLayout } from "./components/layout/UserLayout";
import PageHero from "./components/PageHero";
import Container from "./components/Container";
import Accordion from "./components/Accordion";
import Text from "./components/Text";
import { useFetchFAQsDataQuery } from "../../stores/api/pages.api";

const FAQ = () => {
  const { data: sections = [], isLoading } = useFetchFAQsDataQuery();
  const sectionRefs = useRef({});

  const scrollTo = (id) => {
    sectionRefs.current[id]?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <UserLayout>
      <PageHero title="FAQ" crumbs={[{ label: "FAQ" }]} />

      <Container variant="narrow" className="py-16 px-4 lg:px-0">
        {isLoading ? (
          <div className="space-y-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="animate-pulse space-y-3">
                <div className="h-5 bg-gray-200 rounded w-1/3" />
                <div className="h-12 bg-gray-100 rounded" />
                <div className="h-12 bg-gray-100 rounded" />
              </div>
            ))}
          </div>
        ) : sections.length === 0 ? (
          <Text is="p" className="text-gray-400 text-sm text-center py-16">No FAQs available.</Text>
        ) : (
          <div className="flex gap-10 items-start">
            {/* Sticky aside */}
            <aside className="hidden lg:block w-64 flex-shrink-0 sticky top-24">
              <div className="border border-gray-200 rounded-sm overflow-hidden">
                {sections.map((section, i) => (
                  <button
                    key={section.id}
                    onClick={() => scrollTo(section.id)}
                    className={`w-full text-left px-5 py-4 text-sm font-semibold text-gray-800 hover:text-blue-500 transition-colors ${i < sections.length - 1 ? "border-b border-gray-100" : ""}`}
                  >
                    {section.section_name}
                  </button>
                ))}
              </div>
            </aside>

            {/* Content */}
            <div className="flex-1 space-y-12 min-w-0">
              {sections.map((section) => (
                <div key={section.id} ref={(el) => (sectionRefs.current[section.id] = el)}>
                  <Text is="h2" className="text-xl font-bold text-gray-900 mb-4">
                    {section.section_name}
                  </Text>
                  <div>
                    {(section.faqs ?? []).map((item, i) => (
                      <Accordion
                        key={item.id ?? i}
                        question={item.question}
                        answer={item.answer}
                        defaultOpen={i === 0}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Container>
    </UserLayout>
  );
};

export default FAQ;
